import axios from "axios";
import { message } from "antd";
import { createHashHistory } from "history";
const history = createHashHistory();

const { BASEURL } = window.globalConfig;
const instance = axios.create({
  baseURL: `/${BASEURL}`,
  timeout: 500000,
  headers: { "X-Custom-Header": "foobar", "Content-Type": "application/json" },
});
instance.interceptors.request.use(
  async (config) => {
    if (config.url == "/system/0/media/play") {
      config.baseURL = window.globalConfig.MEDIAPLAYURL;
    }
    const token = sessionStorage.getItem("token");
    if (token) {
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      config.headers.authorization = token;
      config.headers["X-UID"] = userInfo.id;
    }
    config.headers["TENANT-ID"] = sessionStorage.getItem("TENANT-ID");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  ({ data, config }) => {
    if (data.status === "100") {
      sessionStorage.removeItem("token");
      history.replace("/login");
    } else if (!config.useMineErrMsg) {
      if (data.status && data.status !== "0") {
        message.error(data.message);
      } else if (!!data.state && data.state != "SUCCESS") {
        message.error(data.message);
      }
    }
    return data;
  },
  (error) => {
    if (error.response.status === 500) {
      message.error(error.response.data.message);
    }
    let text =
      JSON.parse(JSON.stringify(error)).response.status === 404
        ? "404"
        : "网络异常，请重试";
    message.error(text);
    return Promise.reject({ status: -1, message: text });
  }
);

const request = {
  appid: async (url, config) => {
    return instance
      .get(url, config)
      .then((data) => {
        if (data) {
          return data;
        }
      })
      .catch((error) => {
        return error;
      });
  },
  get: async (url, param, config) => {
    param = param || {};
    return instance
      .get(url, param, config)
      .then((data) => {
        if (data) {
          return data;
        }
      })
      .catch((error) => {
        return error;
      });
  },
  post: async (url, param, config) => {
    param = param || {};
    return instance
      .post(url, param, config)
      .then((data) => {
        if (data) {
          return data;
        }
      })
      .catch((error) => {
        return error;
      });
  },
  delete: async (url, param, config) => {
    param = param || {};
    return instance
      .delete(url, param, config)
      .then((data) => {
        if (data) {
          return data;
        }
      })
      .catch((error) => {
        return error;
      });
  },
};
export default request;
